import { lazy, FC, Suspense } from 'react'
import { Route, Routes, Navigate } from 'react-router-dom'
import { MasterLayout } from '../../_metronic/layout/MasterLayout'
import TopBarProgress from 'react-topbar-progress-indicator'
import { DashboardWrapper } from '../pages/dashboard/DashboardWrapper'
import { getCSSVariableValue } from '../../_metronic/assets/ts/_utils'
import { WithChildren } from '../../_metronic/helpers'
// import { onForegroundMessage } from '../../_metronic/helpers/notification'

const AccountPage = lazy(() => import('../modules/accounts/AccountPage'))
const ServicePage = lazy(() => import('../pages/services/ServicesWrapper'))
const CategoryPage = lazy(() => import('../pages/category/CategoryWrapper'))
const ProductPage = lazy(() => import('../pages/product/ProductWrapper'))
const ProductsGroupPage = lazy(
  () => import('../pages/productsGroup/ProductsGroupWrapper')
)
const CompanyEmployeePage = lazy(
  () => import('../pages/manageUsers/companyEmployee/CompanyEmployeeWrapper')
)
const ConsumerPage = lazy(
  () => import('../pages/manageUsers/consumer/ConsumerWrapper')
)
const AdminPage = lazy(() => import('../pages/manageUsers/admin/AdminWrapper'))
const ProviderPage = lazy(
  () => import('../pages/manageUsers/provider/ProviderWrapper')
)
const ProviderDetailPage = lazy(
  () => import('../pages/manageUsers/provider/ProviderDetailWrapper')
)

const AppointmentPage = lazy(() => import('../pages/booking/AppontmentWrapper'))

const AccountListPage = lazy(() => import('../pages/acccount/AccountWrapper'))
const AppointmentDetailPage = lazy(
  () => import('../pages/booking/AppointmentDetailWrapper')
)

const PaymentTransactionPage = lazy(
  () => import('../pages/paymentTransaction/paymentTransactionWrapper')
)

const Banners = lazy(() => import('../pages/banner/BannerWrapper'))

const TransactionPage = lazy(
  () => import('../pages/transaction/TransactionWrapper')
)

const Commission = lazy(() => import('../pages/commission/CommissionWrapper'))
const SlotPage = lazy(() => import('../pages/slot/SlotWrapper'))
const PromoCodePage = lazy(() => import('../pages/promo-code/PromoCodeWrapper'))
const QuestionarePage = lazy(
  () => import('../pages/questionare/QuestionareWrapper')
)
const NotificationsPage = lazy(
  () => import('../pages/notification/NotificationPage')
)
const BlogPage = lazy(() => import('../pages/blog/BlogWrapper'))
const FAQPage = lazy(() => import('../pages/faq/FAQWrapper'))
const PolicyPage = lazy(() => import('../pages/policy/PolicyWrapper'))

const PrivateRoutes = () => {
  //* for future use
  // const navigate = useNavigate()

  // useEffect(() => {
  //     onForegroundMessage(navigate)
  //     // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [])
  return (
    <Routes>
      <Route element={<MasterLayout />}>
        {/* Redirect to Dashboard after success login/registartion */}
        <Route path='auth/*' element={<Navigate to='/dashboard' />} />
        {/* Pages */}
        <Route path='dashboard' element={<DashboardWrapper />} />
        <Route path='services' element={<ServicePage />} />
        <Route path='service/:serviceId/category' element={<CategoryPage />} />
        <Route path='products' element={<ProductPage />} />
        <Route path='product-group' element={<ProductsGroupPage />} />
        <Route
          path='manage-user/company-employee'
          element={<CompanyEmployeePage />}
        />
        <Route path='manage-user/patients' element={<ConsumerPage />} />
        <Route path='manage-user/professionals' element={<ProviderPage />} />
        <Route
          path='manage-user/professionals/:id'
          element={<ProviderDetailPage />}
        />
        <Route path='manage-user/admins' element={<AdminPage />} />
        <Route path='appointment' element={<AppointmentPage />} />
        <Route path='account' element={<AccountListPage />} />
        <Route
          path='payment-transaction'
          element={<PaymentTransactionPage />}
        />
        <Route
          path='appointment/:appointmentId'
          element={<AppointmentDetailPage />}
        />
        <Route path='banner-management' element={<Banners />} />
        <Route path='transaction' element={<TransactionPage />} />
        <Route path='commission' element={<Commission />} />
        <Route path='slot' element={<SlotPage />} />
        <Route path='promo-code' element={<PromoCodePage />} />
        <Route path='notifications' element={<NotificationsPage />} />
        <Route path='blogs' element={<BlogPage />} />
        <Route path='questionare' element={<QuestionarePage />} />
        <Route path='faq' element={<FAQPage />} />
        <Route path='policy' element={<PolicyPage />} />

        {/* Lazy Modules */}
        <Route
          path='settings'
          element={
            <SuspensedView>
              <AccountPage />
            </SuspensedView>
          }
        />

        {/* Page Not Found */}
        <Route path='*' element={<Navigate to='/error/404' />} />
      </Route>
    </Routes>
  )
}

const SuspensedView: FC<WithChildren> = ({ children }) => {
  const baseColor = getCSSVariableValue('--kt-primary')
  TopBarProgress.config({
    barColors: {
      '0': baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  })
  return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>
}

export { PrivateRoutes }
